import BaseService from '@src/services/BaseService'

class WorkScheduleVisitCheckService extends BaseService {
    constructor() {
        super('work-schedules')
    }

    fetchStatus(params) {
        return this.axios.post(`${this.getUrl()}/visit-checks/status`, params)
    }

    checkIn(workScheduleId, params) {
        return this.axios.post(`${this.getUrl()}/${workScheduleId}/visit-checks/in`, params)
    }

    checkOut(workScheduleId, params) {
        return this.axios.post(`${this.getUrl()}/${workScheduleId}/visit-checks/out`, params)
    }
}

export default new WorkScheduleVisitCheckService()
